"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegionRoutes = void 0;
var RegionRoutes;
(function (RegionRoutes) {
    RegionRoutes["BasePrefix"] = "regions";
    RegionRoutes["ById"] = ":regionId";
    RegionRoutes["All"] = "all";
    RegionRoutes["List"] = "list";
})(RegionRoutes = exports.RegionRoutes || (exports.RegionRoutes = {}));
